import { render, staticRenderFns } from "./PopoverPayment.vue?vue&type=template&id=bd7cc706"
import script from "./PopoverPayment.vue?vue&type=script&lang=js"
export * from "./PopoverPayment.vue?vue&type=script&lang=js"
import style0 from "./PopoverPayment.vue?vue&type=style&index=0&id=bd7cc706&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports